import { LiksDialog } from '../../components/liks/LiksDialog/LiksDialog';
import type { AssignedDirectoryUser } from '../../types/user';
import {
  TenantResourceUserAssignments,
  type TenantAssignableUser,
} from './TenantResourceUserAssignments';
import './TenantResourceUserAssignments.css';

type TenantResourceUsersDialogProps = {
  title: string;
  closeLabel: string;
  assignedUsers: ReadonlyArray<AssignedDirectoryUser>;
  directoryUsers: ReadonlyArray<TenantAssignableUser>;
  isLoading?: boolean;
  isError?: boolean;
  pendingUserId?: string | null;
  isBusy?: boolean;
  onAssign: (userId: string) => void;
  onUnassign: (userId: string) => void;
  onClose: () => void;
};

export function TenantResourceUsersDialog({
  title,
  closeLabel,
  assignedUsers,
  directoryUsers,
  isLoading = false,
  isError = false,
  pendingUserId = null,
  isBusy = false,
  onAssign,
  onUnassign,
  onClose,
}: TenantResourceUsersDialogProps) {
  return (
    <LiksDialog
      isOpen
      size="md"
      title={title}
      onClose={onClose}
      closeLabel={closeLabel}
      closeDisabled={isBusy}
      isDismissDisabled={isBusy}
    >
      <TenantResourceUserAssignments
        assignedUsers={assignedUsers}
        directoryUsers={directoryUsers}
        isLoading={isLoading}
        isError={isError}
        pendingUserId={pendingUserId}
        onAssign={onAssign}
        onUnassign={onUnassign}
      />
    </LiksDialog>
  );
}
